const authStatus = (state) => state.auth.auth.status;
const authData = (state) => state.auth.auth.data;
const authType = (state) => state.auth.auth.type;

const accountUpdateStatus = (state) => state.auth.update_account.status;
const accountUpdateData = (state) => state.auth.update_account.data;

const passwordUpdateStatus = (state) => state.auth.update_password.status;
const passwordUpdateData = (state) => state.auth.update_password.data;

const myDatasetsStatus = (state) => state.auth.my_datasets.status;
const myDatasetsData = (state) => state.auth.my_datasets.data;

const deActivateStatus = (state) => state.auth.de_activate.status;

const VendorSettingsData = (state) => state.auth.vendor_settings.data;
const VendorSettingsStatus = (state) => state.auth.vendor_settings.status;

const loggedIn = (state) => state.auth.logged_in;

export const authenticationState = {
  authStatus,
  authData,
  authType,

  accountUpdateStatus,
  accountUpdateData,
  passwordUpdateStatus,
  passwordUpdateData,

  myDatasetsData,
  myDatasetsStatus,

  deActivateStatus,

  VendorSettingsData,
  VendorSettingsStatus,

  loggedIn,
};
